// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Guarantee_wrapper__3fmaP","user":"Guarantee_user__1qA5K","infoWrapper":"Guarantee_infoWrapper__46wR1","avatar":"Guarantee_avatar__30KRA"};